type DiffType = "added" | "removed";

interface Difference {
	type: DiffType;
	start: number;
	end: number;
	text: string;
}

export function findDifferences(str1: string, str2: string): Difference[] {
	let i = 0;
	let j = 0;
	const diffs: Difference[] = [];

	while (i < str1.length || j < str2.length) {
		if (i >= str1.length) {
			// Remaining characters in str2 are additions
			diffs.push({
				type: "added",
				start: j,
				end: str2.length,
				text: str2.slice(j),
			});
			break;
		}
		if (j >= str2.length) {
			// Remaining characters in str1 are removals
			diffs.push({
				type: "removed",
				start: i,
				end: str1.length,
				text: str1.slice(i),
			});
			break;
		}

		if (str1[i] === str2[j]) {
			i++;
			j++;
		} else {
			// Check for removal in str1
			const removeStart: number = i;
			while (i < str1.length && str1[i] !== str2[j]) {
				i++;
			}
			if (removeStart !== i) {
				diffs.push({
					type: "removed",
					start: removeStart,
					end: i,
					text: str1.slice(removeStart, i),
				});
			}

			// Check for addition in str2
			const addStart: number = j;
			while (j < str2.length && str1[i] !== str2[j]) {
				j++;
			}
			if (addStart !== j) {
				diffs.push({
					type: "added",
					start: addStart,
					end: j,
					text: str2.slice(addStart, j),
				});
			}
		}
	}

	return diffs;
}
